export enum EPassengerType
{
       "none" = 0,
       "employee" = 1,
       "nonEmployee" = 2,
       "child" = 3
}